import UserInfo from "@/entity/UserInfo";

export default {
    token: (state: any): string => state.token,
    userInfo: (state: any): UserInfo => state.userInfo,
    pageRole: (state: any): any => state.pageRole,
};
